import React from 'react';

const Footer = () => {
  return (
    <footer style={{
      backgroundColor: '#333',
      color: 'white',
      padding: '20px',
      textAlign: 'center'
    }}>
      <p>&copy; {new Date().getFullYear()} Fresh Harvest Organic Fruits</p>
    </footer>
  );
};

export default Footer;
